
import mentions from '@/data/social-mentions.json'
import { cropUrl } from '@/utils/images'
import {
  formatStoryAge,
  instagramStories,
  readSeenStories,
  rememberSeen,
  writeSeenStories,
} from '@/utils/instagramStories'

const PROD_ORIGIN = 'https://www.agmvision.com'

const absolute = url => (url && url.startsWith('/') ? PROD_ORIGIN + url : url)

export default {
  name: 'HomeSocialProof',
  components: {
    InstagramLogo: () => import('@/components/InstagramLogo.vue'),
    InstagramStoriesViewer: () =>
      import('@/components/InstagramStoriesViewer.vue'),
  },
  data() {
    return {
      isVisible: false,
      observer: null,
      stories: [],
      storiesLoading: true,
      followers: {},
      seenIds: [],
      viewerOpen: false,
      startIndex: 0,
      playingIds: [],
      videoObserver: null,
      shelfCanLeft: false,
      shelfCanRight: false,
      socialLinks: [
        {
          name: 'Facebook',
          network: 'facebook',
          handle: 'agmvision',
          brand: '#1877F2',
          url: 'https://www.facebook.com/agmvision/',
          glowClass: 'tw-bg-blue-600',
          color: '#1877F2',
          viewBox: '0 0 448 512',
          path: 'M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z',
        },
        {
          name: 'Instagram',
          network: 'instagram',
          handle: 'agm_vision',
          brand: '#E4405F',
          url: 'https://www.instagram.com/agm_vision/',
          glowClass: 'tw-bg-pink-600',
          color: '#E4405F',
          viewBox: '0 0 448 512',
          path: 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z',
        },
        {
          name: 'TikTok',
          network: 'tiktok',
          handle: 'agmvision',
          brand: '#000000',
          light: '#0c1524',
          url: 'https://www.tiktok.com/@agmvision',
          glowClass: 'tw-bg-cyan-400',
          color: '#FFFFFF',
          viewBox: '0 0 448 512',
          path: 'M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z',
        },
        {
          name: 'YouTube',
          network: 'youtube',
          handle: 'agmvision',
          brand: '#FF0000',
          url: 'https://www.youtube.com/@agmvision',
          glowClass: 'tw-bg-red-600',
          color: '#FF0000',
          viewBox: '0 0 576 512',
          path: 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 42.276 48.284 48.597C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.322 42.003-24.947 48.284-48.597 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305z',
          path2: 'M232.145 337.591V175.185l142.739 81.205-142.739 81.201z',
          color2: '#FFFFFF',
        },
      ],
    }
  },
  async fetch() {
    try {
      const { data } = await this.$socialFollowersService.fetch()
      this.followers = data || {}
    } catch {
      this.followers = {}
    }
  },
  computed: {
    limitedMentions() {
      return mentions.filter(m => m.name !== 'razz_biker').slice(0, 8)
    },
  },
  watch: {
    variant() {
      this.$nextTick(() => {
        this.observeVideos()
        this.updateShelfArrows()
      })
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateShelfArrows)
    this.seenIds = readSeenStories()
    this.loadStories()
    this.observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          this.isVisible = true
          this.observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )

    this.observer.observe(this.$refs.container)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    if (this.videoObserver) this.videoObserver.disconnect()
    window.removeEventListener('resize', this.updateShelfArrows)
  },
  methods: {
    followersLabel(network) {
      const count = this.followers[network]
      if (!count) return null
      return this.$t('pages.index.socialProof.followersCount', {
        count: new Intl.NumberFormat(this.$i18n.locale, {
          notation: 'compact',
          maximumFractionDigits: 1,
        }).format(count),
      })
    },
    async loadStories() {
      try {
        const { data } = await this.$instagramStoriesService.fetch()
        this.stories = instagramStories(data)
        if (!this.stories.length && process.env.NODE_ENV !== 'production') {
          const response = await fetch(
            `${PROD_ORIGIN}/api/v2/instagram-stories`
          )
          const prod = await response.json()
          this.stories = instagramStories(
            (prod.data || []).map(story => ({
              ...story,
              video_url: absolute(story.video_url),
              image: story.image && {
                ...story.image,
                url: absolute(story.image.url),
              },
            }))
          )
        }
      } catch {
        this.stories = []
      } finally {
        this.storiesLoading = false
        this.$nextTick(() => {
          this.observeVideos()
          this.updateShelfArrows()
        })
      }
    },
    autoplayAllowed() {
      const reduced = window.matchMedia?.(
        '(prefers-reduced-motion: reduce)'
      ).matches
      return !reduced && !navigator.connection?.saveData
    },
    observeVideos() {
      if (this.videoObserver) this.videoObserver.disconnect()
      const videos = this.$refs.storyVideos || []
      if (!videos.length || !this.autoplayAllowed()) return
      this.videoObserver = new IntersectionObserver(
        entries =>
          entries.forEach(entry => {
            if (entry.intersectionRatio >= 0.6 && !this.viewerOpen) {
              entry.target.muted = true
              entry.target.play()?.catch(() => {})
            } else {
              entry.target.pause()
            }
          }),
        { threshold: [0, 0.6] }
      )
      videos.forEach(video => this.videoObserver.observe(video))
    },
    updateShelfArrows() {
      const shelf = this.$refs.shelf
      if (!shelf) return
      this.shelfCanLeft = shelf.scrollLeft > 4
      this.shelfCanRight =
        shelf.scrollLeft + shelf.clientWidth < shelf.scrollWidth - 4
    },
    scrollShelf(direction) {
      const shelf = this.$refs.shelf
      if (!shelf) return
      shelf.scrollBy({
        left: direction * shelf.clientWidth * 0.8,
        behavior: 'smooth',
      })
    },
    setPlaying(id, playing) {
      this.playingIds = playing
        ? [...new Set([...this.playingIds, id])]
        : this.playingIds.filter(playingId => playingId !== id)
    },
    closeViewer() {
      this.viewerOpen = false
      this.$nextTick(this.observeVideos)
    },
    storyPreview(story) {
      return story.image ? cropUrl(story.image, 256, 456, 'jpg') : '/icon.png'
    },
    storyAge(story) {
      return formatStoryAge(story.publishedAt, this.$i18n.locale)
    },
    openStory(index) {
      ;(this.$refs.storyVideos || []).forEach(video => video.pause())
      this.startIndex = index
      this.viewerOpen = true
    },
    markSeen(id) {
      this.seenIds = rememberSeen(this.seenIds, id, this.stories)
      writeSeenStories(this.seenIds)
    },
    platformIcon(platform) {
      const icons = {
        youtube: ['fab', 'youtube'],
        tiktok: ['fab', 'tiktok'],
        instagram: ['fab', 'instagram'],
        facebook: ['fab', 'facebook-f'],
      }
      return icons[platform] || ['fas', 'link']
    },
    platformBg(platform) {
      const bg = {
        youtube: 'tw-bg-red-600',
        tiktok: 'tw-bg-black',
        instagram: 'tw-bg-pink-600',
        facebook: 'tw-bg-blue-600',
      }
      return bg[platform] || 'tw-bg-gray-600'
    },
  },
}
